import moment from "moment";
import AppMessages from "../../../config/AppMessages";
import SettingsHelper from "../more/SettingsHelper";
import SetupConfig from "../home/cards/onboarding/SetupConfig";

const DATE_FORMAT = "YYYY-MM-DD";

const SAVE_FIELDS = [
  "resolution_id",
  "description",
  "from",
  "to",
  "how",
  "importance",
  "mood",
  "operator",
  "target_name",
  "target_type",
  "target_id",
  "target_hours",
  "time_unit",
];

_getLastSunday = () => {
  const startDay = moment().format("DD");

  let result = moment()
    .add(startDay > 15 ? 1 : 0, "month")
    .endOf("month");
  while (result.day() !== 0) {
    result.add(-1, "day");
  }
  return result.format(DATE_FORMAT);
};

const getGoalModel = ({ showTutorials, model }) => {
  // Goal starts next Monday and runs for one month
  const from = moment().startOf("isoWeek").add(1, "week");
  const to = from.clone().add(1, "month");

  return showTutorials
    ? {
        target_hours: "0.25",
        weekdays: "0000001",
        to: _getLastSunday(),
        operator: "exactly",
        time_unit: "week",
        importance: 5,
        description: AppMessages.NewGoalDescription,
        how: AppMessages.NewGoalHow,
      }
    : model
    ? {
        target_hours: "1",
        weekdays: "1111111",
        operator: "more than",
        time_unit: "week",
        importance: 5,
        from: from.format(DATE_FORMAT),
        to: to.format(DATE_FORMAT),
        ...model
      }
    : {
        target_hours: "1",
        weekdays: "1111111",
        operator: "more than",
        time_unit: "week",
        importance: 5,
        from: from.format(DATE_FORMAT),
        to: to.format(DATE_FORMAT),
      };
};

// ------------------------------------- SAVE -------------------------------------
const saveGoal = (controller, goal, callback = () => {}) => {
  let model = { edit_is_active: true };

  SAVE_FIELDS.forEach((key) => {
    let edit_key = key == "resolution_id" ? "edit_id" : `edit_${key}`;
    if (key == "from") edit_key = "edit_start";
    if (key == "to") edit_key = "edit_end";

    model[edit_key] = goal[key] ? goal[key].toString() : "";
  });

  (goal.weekdays?.split("") || []).forEach((option, index) => {
    model[`day${index + 1}`] = option;
  });

  controller.tracking.track("Edit Goal");
  controller.apiService
    .cardAction({
      action: "save",
      target: "target",
      ...model,
    })
    .then(() => {
      // Save current step in settings for checklist display
      SettingsHelper.updateSetupProgress(controller, {
        [SetupConfig.goals.name]: true,
      });

      callback();
    });
};

const GoalsHelper = {
  getGoalModel,
  saveGoal,
};

export default GoalsHelper;
